import { render, staticRenderFns } from "./demand-list.vue?vue&type=template&id=657b5a21"
import script from "./demand-list.vue?vue&type=script&lang=js"
export * from "./demand-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports